import { createEl } from 'lmnt';

export default class Yoke {
  constructor(state, parallax) {
    this.state = state;

    this.maxRotate = 15;

    this.el = createEl('div', { className: 'airplane-yoke' });
    this.yoke = createEl('img', { className: 'airplane-yoke-image', src: 'assets/images/yoke/Yoke.png' });
    this.yoke.setAttribute("alt", "Cockpit steering wheel");      
    
    this.el.append(this.yoke);

    this.onDirectionChanged = this.onDirectionChanged.bind(this);
    parallax.addEventListener('onDirectionChanged', this.onDirectionChanged);
  }

  onDirectionChanged(e) {
    if (e.direction === 'left') this.yoke.style.transform = `rotate(-${this.maxRotate}deg)`;
    if (e.direction === 'right') this.yoke.style.transform = `rotate(${this.maxRotate}deg)`;
    if (e.direction === 'idle') this.yoke.style.transform = 'rotate(0deg)';
  }
}
